import { sign, type Algorithm } from 'jsonwebtoken';

export type JWTTokenType = 'BR' | 'AMS';

const jwtTokenMap = {
  BR: { issValue: 'procore-monolith', algorithm: 'HS256' },
  AMS: { issValue: 'SelfServeAccounts', algorithm: 'ES512' },
};

const generateJWTTokenBase = (type: JWTTokenType) => {
  const brJWTPivateKey = process.env.BR_JWT_PRIVATE_KEY;
  const amsJWTPrivateKey = process.env.AMS_JWT_PRIVATE_KEY;
  const secret = type === 'BR' ? brJWTPivateKey : amsJWTPrivateKey;
  if (!secret) {
    throw new Error(`${type}_JWT_PRIVATE_KEY is required.`);
  }
  // Default expiration of 60 seconds
  const expiresIn = 60000;
  const payload = { iss: jwtTokenMap[type].issValue };
  const { algorithm } = jwtTokenMap[type];

  return sign(payload, secret, {
    algorithm: algorithm as Algorithm,
    expiresIn,
  });
};

export default function generateAMSJWTToken() {
  return generateJWTTokenBase('AMS');
}

export function generateBRJWTToken() {
  return generateJWTTokenBase('BR');
}
